/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Alert } from "react-bootstrap";
import Spinner from '../../../../partials/layout/Spinner';
import * as compensationEventCrud from '../../../../crud/compensationEvent.crud';
import { injectIntl } from "react-intl";
import { confirm } from 'devextreme/ui/dialog';
import * as taskOrderCrud from '../../../../crud/taskOrder.crud';
import * as projectOrderCrud from '../../../../crud/projectOrder.crud';
import DataSource from 'devextreme/data/data_source';
import Common from '../../../../shared/common';

class AssessmentCustomForm extends React.Component {
    constructor(props) {
        super(props);
        this.createDefaultSubject = (((props.location || {}).state || {}).itemCustomProps || {}).subject;
        this.createDefaultAsset = (((props.location || {}).state || {}).itemCustomProps || {}).assetid;
        this.createDefaultFields = ((props.location || {}).state || {});

        this.validatorRef = props.validatorRef ? props.validatorRef : React.createRef();

        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        this.createDefaultClause = (((props.location || {}).state || {}).itemCustomProps || {}).clauseDisplay;

        this.state = {
            isDxFormValid: true,
            compensations: null,
            selectedCompensation: null,
            taskOrderOptions: null,
            projectOrderOptions: null,
            dateSectionFilters: []
        };
    }
    componentDidMount() {
        const { fields } = this.props.workflowItem;
        if (fields.CompensationEvent.visible) {
            this.fetchCompensations();
        }
        if (fields.TaskOrder.visible) {
            this.fetchTaskOrders();
        }
        if (fields.ProjectOrder.visible) {
            this.fetchProjectOrders();
        }
    }
    fetchCompensations = async () => {
        try {
            const { contractid } = this.props.contract;
            const assessmentStates = ['APMA', 'ARQ', 'APMRQ', 'AQ'];
            const { data: responseObj } = await compensationEventCrud.getCompansationEventsToSelectList(contractid, assessmentStates);
            let comps = responseObj.map(itm => {
                let reference = itm.referenceid;

                let reason = null;
                if (itm.status === 'APMA') {
                    reason = 'Not Accepted';
                }
                else if (itm.status === 'AQ' || itm.status === 'ARQ') {
                    if (new Date(itm.requiredate) < new Date()) {
                        reason = 'Expired';
                    }
                }

                return {
                    value: itm.compensationeventid,
                    reference: reference,
                    reason: reason,
                    title: itm.compensationnumber,
                    type: itm.compensationsource,
                    taskorderid: itm.taskorderid,
                    projectorderid: itm.projectorderid,
                    clauseeffect: itm.clauseeffect,
                    display: `${reference}   {${itm.compensationnumber}}` + (reason ? ` [${this.props.intl.formatMessage({ id: "OPTIONS.STATUS." + reason })}]` : '')
                }
            });

            // the right hand side of the operator ?? added for the case that comes from create related pm assessment in pm ce
            // to be able to filter secondary dates according to task/project order ids in  that are related to the populated ce
            let cenID = (this.props.item || {}).replyactiondetail
            if (!cenID) {
                cenID = this.createDefaultFields?.itemBaseProps?.reftype === 'CompensationEvent' ? Number(this.createDefaultFields?.itemBaseProps?.refid) : null;
            }

            const selectedCompensation = comps.find(x => x.value === cenID);

            if (selectedCompensation) {
                if (this.props.ceTypeHandler) {
                    this.props.ceTypeHandler(selectedCompensation.type);
                }
            }

            this.setState({ compensations: comps, selectedCompensation: selectedCompensation }, () => this.setSelectedCEIfConditionsMet(comps));
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchTaskOrders = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: responseObj } = await taskOrderCrud.getTaskOrdersToSelectList(contractid);
            //COVERTED TO DATASOURCE WITH FD-11007 DUE TO PERFORMENCE ISSUES AFTER 3K ITEMS
            const taskOrderOptions = new DataSource({
                store: {
                    type: 'array',
                    data: responseObj,
                    key: 'value'
                }
            });
            this.setState({ taskOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchProjectOrders = async () => {
        try {
            const { contractid, ispackaged } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);
            const projectOrderOptions = responseObj.map(TO => {
                let displayValue = "";
                if (ispackaged) {
                    if (TO.linkedprojectcode) {
                        displayValue += `[${TO.linkedprojectcode}] - `;
                    }
                    if (TO.linkedprojectname) {
                        displayValue += `${TO.linkedprojectname} - `;
                    }
                    if (TO.projectordernumber) {
                        displayValue += `${TO.projectordernumber} - `;
                    }
                    if (TO.purchaseordervalue) {
                        displayValue += `${Common.FormatCurrencyNum(TO.purchaseordervalue, (this.props.contract || {}).currency)} - `;
                    }
                }
                displayValue += `${TO.referenceid} - ${TO.subject}`;
                return {
                    value: TO.projectorderid,
                    reference: TO.referenceid,
                    display: displayValue
                }
            });
            this.setState({ projectOrderOptions: projectOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    setSelectedCEIfConditionsMet = (ceList) => {
        if (this.createDefaultFields?.itemBaseProps?.reftype === 'CompensationEvent' && ceList) {
            const ceOption = ceList.find(x => x.value == this.createDefaultFields.itemBaseProps.refid);
            if (ceOption) {
                this.setState({ selectedCompensation: ceOption });
            }
        }
    }


    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        this.state.isDxFormValid = isDxFormValid;
        if (field) {
            if (field === 'replyactiondetail' && this.props.mode === "PM") {
                if (value) {
                    const selectedCompensation = this.state.compensations.find(x => x.value === value);

                    this.setState({ selectedCompensation });


                    if (this.props.valueChangeHandler) {
                        const compOpt = this.state.compensations.find(x => x.value === value);
                        this.props.valueChangeHandler('selectedCompensationType', compOpt.type, isDxFormValid, additionalData);
                        this.props.valueChangeHandler('replyaction', compOpt.reference, isDxFormValid, additionalData);
                        this.props.valueChangeHandler('location', compOpt.title, isDxFormValid, additionalData);
                        this.props.valueChangeHandler('reason', compOpt.reason, isDxFormValid, additionalData);
                        this.props.valueChangeHandler('replyactiondetail', value, isDxFormValid, additionalData);
                    }
                }
                else {
                    if (this.props.valueChangeHandler) {
                        this.props.valueChangeHandler('replyaction', value, isDxFormValid, additionalData);
                    }
                }
            } else if ((this.props.mode === 'PM_TIME' || this.props.mode === 'PM_PRICE') && field === 'taskorderid') {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);

                    if (this.props.mode === 'PM_TIME' || this.props.mode === 'PM_PRICE') {
                        if (field === 'taskorderid') {
                            if (value) {
                                this.props.valueChangeHandler('taskorderid', value, isDxFormValid, additionalData);
                                if (additionalData) {
                                    this.props.valueChangeHandler('taskorderreference', additionalData.referenceid, isDxFormValid, additionalData);
                                }
                            }
                            else {
                                this.props.valueChangeHandler('taskorderid', value, isDxFormValid, additionalData);
                                this.props.valueChangeHandler('taskorderreference', "", isDxFormValid, additionalData);
                            }
                        }
                    }
                }
            } else if ((this.props.mode === 'PM_TIME' || this.props.mode === 'PM_PRICE') && field === 'projectorderid') {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);

                    if (this.props.mode === 'PM_TIME' || this.props.mode === 'PM_PRICE') {
                        if (field === 'projectorderid') {
                            if (value) {
                                this.props.valueChangeHandler('projectorderid', value, isDxFormValid, additionalData);
                                if (additionalData) {
                                    this.props.valueChangeHandler('projectorderreference', additionalData.reference, isDxFormValid, additionalData);
                                }
                            }
                            else {
                                this.props.valueChangeHandler('projectorderid', value, isDxFormValid, additionalData);
                                this.props.valueChangeHandler('projectorderreference', "", isDxFormValid, additionalData);
                            }
                        }
                    }
                }
            } else {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
            }
        }

    }
    confirmPositiveAmount = async (notification) => {
        if (this.state.selectedCompensation?.type === 'CLIENTCWN' || this.state.selectedCompensation?.type === 'CLIENT') {
            if (notification.replycomment > 0) { // amount field
                const warningMessage = this.props.intl.formatMessage({ id: 'GENERAL.FORMS.POSITIVE_AMOUNT_WARNING' });
                const warningMessageLabel = this.props.intl.formatMessage({ id: 'GENERAL.FORMS.POSITIVE_AMOUNT_WARNING_LABEL' });
                let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageLabel}`);
                return result;
            }

            return true;
        }

        return true;
    }
    onSubmitHandler = async (notification, setSubmitting) => {
        const positiveAmountConfirmed = await this.confirmPositiveAmount(notification);

        if (!positiveAmountConfirmed) {
            //if not confirmed exit save
            setSubmitting(false);
            return;
        } else {
            if (notification.replyactiondetail && this.props.mode === "PM") {
                const compOpt = this.state.compensations.find(x => x.value === notification.replyactiondetail);
                notification.replyaction = compOpt.reference;
                notification.location = compOpt.title;
                notification.reason = compOpt.reason;
            }
            this.props.onSubmitHandler(notification, setSubmitting);
        }
    }
    render() {
        const { fields } = this.props.workflowItem;
        if ((fields.CompensationEvent.visible && !this.state.compensations) ||
            (fields.TaskOrder.visible && !this.state.taskOrderOptions) ||
            (fields.ProjectOrder.visible && !this.state.projectOrderOptions)) {
            return (<Spinner />);
        }

        const visibleConditionEffectField = (item) => {
            if (this.state.selectedCompensation && (this.state.selectedCompensation.type === "CWN" || this.state.selectedCompensation.type === "CLIENTCWN")) {
                return true;
            }
            return false;
        }

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };
        if (fields.CompensationEvent.visible) {
            //AUTO-SELECT CE DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            let defaultCESelection = null;
            if (this.createDefaultFields?.itemBaseProps?.reftype === 'CompensationEvent' && this.state.compensations) {
                const ceOption = this.state.compensations.find(x => x.value == this.createDefaultFields.itemBaseProps.refid);
                if (ceOption) {
                    defaultCESelection = ceOption.value;
                }
            }
            createFormConfig.fields.push({ label: fields.CompensationEvent.label, dataField: 'replyactiondetail', editorType: 'dxSelectBox', editorOptions: { dataSource: this.state.compensations, valueExpr: 'value', displayExpr: 'display', defaultValue: defaultCESelection } });
        }
        if (fields.Type.visible) {
            createFormConfig.fields.push({ label: fields.Type.label, dataField: 'replyactiondetail', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses, valueExpr: 'display', displayExpr: 'display', defaultValue: this.createDefaultClause } });
        }
        if (fields.ContinuingEffect.visible) {
            createFormConfig.fields.push({
                label: fields.ContinuingEffect.label,
                dataField: 'continuingeffect',
                editorType: 'dxSelectBox',
                visible: visibleConditionEffectField,
                editorOptions: { dataSource: fields.ContinuingEffect.interimSelectionOptions, valueExpr: 'value', displayExpr: 'display' },
                dependOn: 'replyactiondetail',
                dependOnValue: (item, additionalData) => { if (additionalData && (additionalData.type === "CWN" || additionalData.type === "CLIENTCWN")) { return item.continuingeffect; } else { return null; } }
            });
        }
        if (fields.Subject.visible) {
            createFormConfig.fields.push({ label: fields.Subject.label, dataField: 'assistancetestserchdefect', editorOptions: { defaultValue: this.createDefaultSubject } });
        }
        if (fields.TaskOrder.visible) {
            //AUTO-SELECT TASK ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            let defaultTaskOrderSelection = null;
            if (this.createDefaultFields?.itemBaseProps?.reftype === 'TaskOrder') {
                defaultTaskOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
            }
            createFormConfig.fields.push({ label: fields.TaskOrder.label, dataField: 'taskorderid', editorType: 'dxSelectBox', required: false, editorOptions: { dataSource: this.state.taskOrderOptions, valueExpr: 'taskorderid', displayExpr: 'display', defaultValue: defaultTaskOrderSelection } });
        }

        if (fields.ProjectOrder.visible) {
            //AUTO-SELECT PROJECT ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            let defaultProjectOrderSelection = null;
            if (this.createDefaultFields?.itemBaseProps?.reftype === 'ProjectOrder') {
                defaultProjectOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
            }
            createFormConfig.fields.push({ label: fields.ProjectOrder.label, dataField: 'projectorderid', editorType: 'dxSelectBox', required: false, editorOptions: { dataSource: this.state.projectOrderOptions, valueExpr: 'value', displayExpr: 'display', defaultValue: defaultProjectOrderSelection } });
        }

        if (fields.PriceEffect.visible ) {
            createFormConfig.fields.push({ 
                visible: this.state.selectedCompensation?.clauseeffect !== "EFFECT_DATES_ONLY",
                label: fields.PriceEffect.label, 
                dataField: 'replycomment', 
                editorType: 'dxNumberBox' 
            });
        }
        if (fields.TimeEffect.visible ) {
            createFormConfig.fields.push({ 
                visible : this.state.selectedCompensation?.clauseeffect !== "EFFECT_AMOUNTS_ONLY",
                label: fields.TimeEffect.label, 
                dataField: 'inspectiontime', 
                editorType: 'dxNumberBox', 
                editorOptions: { format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }) } 
            });
        }
        if (fields.Details.visible) {
            createFormConfig.fields.push({ label: fields.Details.label, dataField: 'inspectiondetails', editorType: 'dxHtmlEditor' });
        }

        return (
            <div>
                {this.props.resources.AssessmentWarningBanner && (
                    <Alert variant="warning" >
                        <span>
                            {
                                this.props.resources.AssessmentWarningBanner.split("\n").map((line, index) => {
                                    return <div key={index}>{line}</div>
                                }
                                )
                            }
                        </span>
                    </Alert>
                )}
                <BiDynamicForm
                    validatorRef={this.validatorRef}
                    item={this.props.item}
                    config={createFormConfig}
                    onSubmitHandler={this.props.onSubmitHandler ? this.onSubmitHandler : null}
                    valueChangeHandler={this.fieldChanged}
                    customFields={this.props.customFields}
                    assetFieldsEnabled={this.props.assetFieldsEnabled}
                    assetid={this.createDefaultAsset}
                    secondaryPriceSectionEnabled={(this.props.mode === "PM" || this.props.mode === "PM_PRICE") && this.state.selectedCompensation?.clauseeffect !== "EFFECT_DATES_ONLY"}
                    secondaryDateSectionEnabled={(this.props.mode === "PM" || this.props.mode === "PM_TIME") && this.state.selectedCompensation?.clauseeffect !== "EFFECT_AMOUNTS_ONLY"}
                    taskorderid={this.props.item?.taskorderid}
                    projectorderid={this.props.item?.projectorderid}
                    interimQuotesAllowed={fields.ContinuingEffect.visible}
                />
            </div>
        );
    }
}

const mapStateToProps = store => ({
    // contract: store.contract.contract,
    // contractTemplate: store.contract.template,
    // globalResources: store.contract.template.resources
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(AssessmentCustomForm)));